import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 7],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Variable curvature arrays",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "simple",
              options: {
                components: {
                  variant: "layout",
                  data: {
                    type: "table",
                    options: {
                      cols: 2,
                      rows: 2,
                      rowsSize: [1, 2],
                      colsSize: [1.2, 1],
                      gap: "0 3%",
                      colSpan: {
                        "1:0": 2,
                      },
                      components: [
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data: `<ul>
                                    <li style="font-size: 14px">Variable curvature arrays are used to have<br> a more even coverage on the audience
                                  </ul>`,
                                  formatter: "html",
                                  scrollbars: false,
                                  styles: {
                                    fontSize: "14px",
                                  },
                                },
                              },
                              styles: {
                                justifyContent: "flex-end",
                                alignItems: "flex-start",
                              },
                            },
                          },
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data: `<ul>
                                  <li style="font-size: 14px">Here, pressure level maps in the vertical <br>plane are given for two array geometries at 1 kHz.<br> See the improvement!
                                </ul>`,
                                  formatter: "html",
                                  scrollbars: false,
                                  styles: {
                                    fontSize: "14px",
                                  },
                                },
                              },
                              styles: {
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "image",
                                options: {
                                  src: `${config.ASSETS_URL}/04/28/principle/principle-4.svg`,
                                },
                              },
                              styles: {
                                paddingBottom: "2%",
                              },
                            },
                          },
                        ],
                      ],
                    },
                    styles: {
                      border: `1px solid ${variables["default"]}`,
                      borderRadius: "10px",
                      padding: "0 3%",
                    },
                  },
                },
              },
              styles: {
                padding: "6% 2%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
